import { useState } from 'react';

import { useUserRanksActions } from 'system/hooks';
import { mapUserRankResourceDataToSend } from 'system/mappers';
import { IAccessRank, IRank } from 'system/types';

import UserRankAccessView from './UserRankAccessView';

interface IProps {
  rank: IRank;
  accessRank: IAccessRank;
}

const getDefaultChecked = (rank: IRank, accessRank: IAccessRank) =>
  accessRank.rankIds?.split(', ').includes(rank.rankId.toString());

const UserRankAccess = ({ rank, accessRank }: IProps) => {
  const [checked, setChecked] = useState(getDefaultChecked(rank, accessRank));

  const { setUserRankResource, setUserRankResourceIsLoading } = useUserRanksActions();

  const onSetUserRankResource = async (
    event: { target: { value: number; checked: boolean } },
    accessRank: IAccessRank
  ) => {
    try {
      await setUserRankResource(
        mapUserRankResourceDataToSend(
          event.target.value,
          accessRank.accessUrl,
          event.target.checked
        )
      );

      setChecked(!checked);
    } catch (error) {}
  };

  return (
    <UserRankAccessView
      rank={rank}
      accessRank={accessRank}
      onSetUserRankResource={onSetUserRankResource}
      checked={checked}
      isLoading={setUserRankResourceIsLoading}
    />
  );
};

export default UserRankAccess;
